module.exports = __webpack_public_path__ + "img/coop1.d70088e4.png";